import React, { createContext, useContext, useState, useCallback, useMemo } from "react"

const GroupPickerContext = createContext({
  open: () => {},
  isOpen: false,
  targetSectionUid: null,
})

export const GroupPickerProvider = ({ children }) => {
  const [target, setTarget] = useState(null)

  const open = useCallback(sectionUid => setTarget(sectionUid || null), [])
  const close = useCallback(() => setTarget(null), [])

  const value = useMemo(() => ({ open, close, isOpen: !!target, targetSectionUid: target }), [open, close, target])

  return (
    <GroupPickerContext.Provider value={value}>
      {children}
    </GroupPickerContext.Provider>
  )
}

export const useGroupPicker = () => useContext(GroupPickerContext)
